/* eslint-disable no-useless-escape */
/* eslint-disable max-len */
import { ModelSnippetFn, Language } from '../types';

const pythonSDK: ModelSnippetFn = (props) => `
from clarifai.client.model import Model
import numpy as np
import cv2

input_text = b"floor plan for 2 bedroom kitchen house"

model_url = "https://clarifai.com/${props.userId}/${props.appId}/models/${props.modelId}"
model_prediction = Model(url=model_url, pat="${props.pat}").predict_by_bytes(input_text)

# Base64 image to numpy array
im_b = model_prediction.outputs[0].data.image.base64
img_np = cv2.imdecode(np.frombuffer(im_b, np.uint8), cv2.IMREAD_COLOR)
cv2.imwrite("output.jpg", img_np)
`;

const python: ModelSnippetFn = (props) => `
#################################################################################################################
# In this section, we set the user authentication, user and app ID, model details, and the prompt text we want
# to provide as an input. Change these strings to run your own example.
#################################################################################################################

# Your PAT (Personal Access Token) can be found in the Account's Security section
PAT = '${props.pat}'
# Specify the correct user_id/app_id pairings
# Since you're making inferences outside your app's scope
USER_ID = '${props.userId}'
APP_ID = '${props.appId}'
# Change these to whatever model and text URL you want to use
MODEL_ID = '${props.modelId}'
MODEL_VERSION_ID = '${props.modelVersionId}'
RAW_TEXT = 'A penguin watching the sunset.'
# To use a hosted text file, assign the URL variable
# TEXT_FILE_URL = 'https://samples.clarifai.com/negative_sentence_12.txt'
# Or, to use a local text file, assign the location variable
# TEXT_FILE_LOCATION = 'YOUR_TEXT_FILE_LOCATION_HERE'

############################################################################
# YOU DO NOT NEED TO CHANGE ANYTHING BELOW THIS LINE TO RUN THIS EXAMPLE
############################################################################

from clarifai_grpc.channel.clarifai_channel import ClarifaiChannel
from clarifai_grpc.grpc.api import resources_pb2, service_pb2, service_pb2_grpc
from clarifai_grpc.grpc.api.status import status_code_pb2

channel = ClarifaiChannel.get_grpc_channel()
stub = service_pb2_grpc.V2Stub(channel)

metadata = (('authorization', 'Key ' + PAT),)

userDataObject = resources_pb2.UserAppIDSet(user_id=USER_ID, app_id=APP_ID)

# To use a local text file, uncomment the following lines
# with open(TEXT_FILE_LOCATION, "rb") as f:
#    file_bytes = f.read()

post_model_outputs_response = stub.PostModelOutputs(
    service_pb2.PostModelOutputsRequest(
        user_app_id=userDataObject,  # The userDataObject is created in the overview and is required when using a PAT
        model_id=MODEL_ID,
        version_id=MODEL_VERSION_ID,  # This is optional. Defaults to the latest model version
        inputs=[
            resources_pb2.Input(
                data=resources_pb2.Data(
                    text=resources_pb2.Text(
                        raw=RAW_TEXT
                        # url=TEXT_FILE_URL
                        # raw=file_bytes
                    )
                )
            )
        ]
    ),
    metadata=metadata
)
if post_model_outputs_response.status.code != status_code_pb2.SUCCESS:
    print(post_model_outputs_response.status)
    raise Exception("Post model outputs failed, status: " + post_model_outputs_response.status.description)

# Since we have one input, one output will exist here
output = post_model_outputs_response.outputs[0].data.image.base64

image_filename = f"gen-image.jpg"
with open(image_filename, 'wb') as f:
      f.write(output)
`;

const javascript: ModelSnippetFn = (props) => `
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// In this section, we set the user authentication, user and app ID, model details, and the prompt text we want
// to provide as an input. Change these strings to run your own example.
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Your PAT (Personal Access Token) can be found in the Account's Security section
const PAT = '${props.pat}';    
// Specify the correct user_id/app_id pairings
// Since you're making inferences outside your app's scope
const USER_ID = '${props.userId}';
const APP_ID = '${props.appId}';
// Change these to whatever model and text you want to use
const MODEL_ID = '${props.modelId}';
const MODEL_VERSION_ID = '${props.modelVersionId}';
const RAW_TEXT = 'A penguin watching the sunset.';
// To use a hosted text file, assign the URL variable
// const TEXT_FILE_URL = 'https://samples.clarifai.com/negative_sentence_12.txt'

///////////////////////////////////////////////////////////////////////////////////
// YOU DO NOT NEED TO CHANGE ANYTHING BELOW THIS LINE TO RUN THIS EXAMPLE
///////////////////////////////////////////////////////////////////////////////////

const raw = JSON.stringify({  
    "inputs": [
    {
        "data": {
          "text": {
                "raw": RAW_TEXT
              // "url": TEXT_FILE_URL
            }
        }
    }
],
      
});

const requestOptions = {
    method: 'POST',
    headers: {
        'Accept': 'application/json',
        'Authorization': 'Key ' + PAT
    },
    body: raw
};

fetch("${props.apiHost}/v2/models/" + MODEL_ID + "/versions/" + MODEL_VERSION_ID + "/outputs", requestOptions)
    .then(response => response.json())
    .then(result => {
            const imageBase64 = result.outputs[0].data.image.base64;
            // Create an anchor element for downloading the image
            const downloadLink = document.createElement('a');
            downloadLink.href = \`data:image/jpeg;base64,\${imageBase64}\`;
            downloadLink.download = 'gen-image.jpg';
            // Trigger a click event on the link to prompt the download
            downloadLink.click();
    })      
    .catch(error => console.log('error', error));
`;

const nodejs: ModelSnippetFn = (props) => `
//index.js file

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// In this section, we set the user authentication, user and app ID, model details, and the prompt text we want
// to provide as an input. Change these strings to run your own example.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Your PAT (Personal Access Token) can be found in the Account's Security section
const PAT = '${props.pat}';    
// Specify the correct user_id/app_id pairings
// Since you're making inferences outside your app's scope
const USER_ID = '${props.userId}';
const APP_ID = '${props.appId}';
// Change these to whatever model and text you want to use
const MODEL_ID = '${props.modelId}';
const MODEL_VERSION_ID = '${props.modelVersionId}';
const RAW_TEXT = 'A penguin watching the sunset.';
// To use a hosted text file, assign the URL variable
// const TEXT_FILE_URL = 'https://samples.clarifai.com/negative_sentence_12.txt'
// Or, to use a local text file, assign the location variable
// TEXT_FILE_LOCATION = 'YOUR_TEXT_FILE_LOCATION_HERE'

/////////////////////////////////////////////////////////////////////////////
// YOU DO NOT NEED TO CHANGE ANYTHING BELOW THIS LINE TO RUN THIS EXAMPLE
/////////////////////////////////////////////////////////////////////////////

const { ClarifaiStub, grpc } = require("clarifai-nodejs-grpc");

const stub = ClarifaiStub.grpc();

// This will be used by every Clarifai endpoint call
const metadata = new grpc.Metadata();
metadata.set("authorization", "Key " + PAT);

// To use a local text file, uncomment the following lines
// const fs = require("fs");
// const fileBytes = fs.readFileSync(TEXT_FILE_LOCATION);

stub.PostModelOutputs(
    {
        user_app_id: {
            "user_id": USER_ID,
            "app_id": APP_ID
        },
        model_id: MODEL_ID,
        version_id: MODEL_VERSION_ID,  // This is optional. Defaults to the latest model version
        inputs: [
            {
                "data": {
                    "text": {
                        "raw": RAW_TEXT
                        // url: TEXT_FILE_URL
                        // raw: fileBytes
                    }
                }
            }
        ],

    },
    metadata,
    (err, response) => {
        if (err) {
            throw new Error(err);
        }

        if (response.status.code !== 10000) {
            throw new Error("Post models failed, status: " + response.status.description);
        }
        // Since we have one input, one output will exist here.
        const output = response.outputs[0].data.image.base64;

        const fs = require('fs');
        const imageFilename = 'gen-image.jpg';
        fs.writeFileSync(imageFilename, Buffer.from(output, 'base64'));
        console.log(\`Image saved as \${imageFilename}\`);

    }
);
`;

const nodejs_SDK: ModelSnippetFn = (props) => `
import { Model } from "clarifai-nodejs";
import fs from "fs";


const inputText: Buffer = Buffer.from("floor plan for 2 bedroom kitchen house");

/**
        The predict API gives flexibility to generate predictions for data provided through URL, Filepath and bytes format.


        Example for prediction through Bytes:
        const modelPrediction = await model.predictByBytes({
                                    inputBytes,
                                    inputType
                                });


        Example for prediction through Filepath:
        const modelPrediction = await model.predictByFilepath({
                                    filepath, 
                                    inputType
                                });
    */

// Image Generation using ${props.modelId}

const modelUrl = "https://clarifai.com/${props.userId}/${props.appId}/models/${props.modelId}"


const model = new Model({
  url: modelUrl,
  authConfig: { pat: "${props.pat}" },
});

const modelPrediction = await model.predictByBytes({
  inputBytes: inputText,
  inputType: "text",
});

// Base64 image to numpy array
const outputBase64 = modelPrediction?.[0]?.data?.image?.base64 ?? "";

fs.writeFileSync("image.png", outputBase64, "base64");
`;

const cURL: ModelSnippetFn = (props) => `
curl -X POST "https://api.clarifai.com/v2/users/${props.userId}/apps/${props.appId}/models/${props.modelId}/versions/${props.modelVersionId}/outputs" \
    -H "Authorization: Key ${props.pat}" \
    -H "Content-Type: application/json" \
    -d '{
      "inputs": [
        {
          "data": {
            "text": {
              "raw": "A penguin watching the sunset."
            }
          }
        }
      ]
    }'
   
`;

const java: ModelSnippetFn = (props) => `
package com.clarifai.example;

import com.clarifai.grpc.api.*;
import com.clarifai.channel.ClarifaiChannel;
import com.clarifai.credentials.ClarifaiCallCredentials;
import com.clarifai.grpc.api.status.StatusCode;
import com.google.protobuf.ByteString;
import java.io.FileOutputStream;
import java.io.IOException;
// import java.io.File; //  Uncomment to use a local text file
// import java.nio.file.Files; //  Uncomment to use a local text file

public class ClarifaiExample {

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // In this section, we set the user authentication, user and app ID, model details, and the prompt text we want
    // to provide as an input. Change these strings to run your own example.
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    // Your PAT (Personal Access Token) can be found in the portal under Authentication
    static final String PAT = ${props.pat};
    // Specify the correct user_id/app_id pairings
    // Since you're making inferences outside your app's scope
    static final String USER_ID =  ${props.userId};
    static final String APP_ID = ${props.appId};
    // Change these to whatever model you want to use
    static final String MODEL_ID = ${props.modelId};
    static final String MODEL_VERSION_ID = ${props.modelVersionId};
    static final String RAW_TEXT = "A penguin watching the sunset.";
    // To use a hosted text file, assign the URL variable
    // static final String TEXT_FILE_URL = "https://samples.clarifai.com/negative_sentence_12.txt";
    // Or, to use a local text file, assign the location variable
    // static final String TEXT_FILE_LOCATION = "YOUR_TEXT_FILE_LOCATION_HERE";

    ///////////////////////////////////////////////////////////////////////////////////
    // YOU DO NOT NEED TO CHANGE ANYTHING BELOW THIS LINE TO RUN THIS EXAMPLE
    ///////////////////////////////////////////////////////////////////////////////////	
    public static void main(String[] args) {

        V2Grpc.V2BlockingStub stub = V2Grpc.newBlockingStub(ClarifaiChannel.INSTANCE.getGrpcChannel())
                .withCallCredentials(new ClarifaiCallCredentials(PAT));

        MultiOutputResponse postModelOutputsResponse = stub.postModelOutputs(
                PostModelOutputsRequest.newBuilder()
                        .setUserAppId(UserAppIDSet.newBuilder().setUserId(USER_ID).setAppId(APP_ID))
                        .setModelId(MODEL_ID)
                        .setVersionId(MODEL_VERSION_ID) // This is optional. Defaults to the latest model version.
                        .addInputs(
                                Input.newBuilder().setData(
                                        Data.newBuilder().setText(
                                                Text.newBuilder().setRaw(RAW_TEXT)
                                        // Text.newBuilder().setUrl(TEXT_FILE_URL)
                                        // Text.newBuilder().setRawBytes(ByteString.copyFrom(Files.readAllBytes(
                                        // new File(TEXT_FILE_LOCATION).toPath()
                                        // )))
                                        )
                                )
                        )
                        .build()
        );

        if (postModelOutputsResponse.getStatus().getCode() != StatusCode.SUCCESS) {
            throw new RuntimeException("Post model outputs failed, status: " + postModelOutputsResponse.getStatus());
        }

        // Extract the base64-encoded image data
        ByteString imageData = postModelOutputsResponse.getOutputs(0).getData().getImage().getBase64();

        // Save the image to a file
        try {
            FileOutputStream outputStream = new FileOutputStream("gen-image.jpg");
            outputStream.write(imageData.toByteArray());
            outputStream.close();
        } catch (IOException e) {
            System.err.println("Error writing image to file: " + e.getMessage());
            System.exit(1);
        }

    }
}

`;

const php: ModelSnippetFn = (props) => `
<?php
require __DIR__ . '/vendor/autoload.php';

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// In this section, we set the user authentication, user and app ID, model details, and the prompt text we want
// to provide as an input. Change these strings to run your own example.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Your PAT (Personal Access Token) can be found in the Account's Security section
$PAT = ${props.pat};
// Specify the correct user_id/app_id pairings
// Since you're making inferences outside your app's scope
$USER_ID = ${props.userId};
$APP_ID = ${props.appId};
// Change these to whatever model and image URL you want to use
$MODEL_ID = ${props.modelId};
$MODEL_VERSION_ID = ${props.modelVersionId};
$RAW_TEXT = 'A penguin watching the sunset.';
# To use a hosted text file, assign the URL variable
# $TEXT_FILE_URL = 'https://samples.clarifai.com/negative_sentence_12.txt';
# Or, to use a local text file, assign the location variable
# $TEXT_FILE_LOCATION = 'YOUR_TEXT_FILE_LOCATION_HERE';

///////////////////////////////////////////////////////////////////////////////////
// YOU DO NOT NEED TO CHANGE ANYTHING BELOW THIS LINE TO RUN THIS EXAMPLE
///////////////////////////////////////////////////////////////////////////////////

use Clarifai\ClarifaiClient;
use Clarifai\Api\Data;
use Clarifai\Api\Text;
use Clarifai\Api\Input;
use Clarifai\Api\PostModelOutputsRequest;
use Clarifai\Api\Status\StatusCode;
use Clarifai\Api\UserAppIDSet;

$client = ClarifaiClient::grpc();

$metadata = ['Authorization' => ['Key ' . $PAT]];

$userDataObject = new UserAppIDSet([
    'user_id' => $USER_ID,
    'app_id' => $APP_ID
]);

//$textData = file_get_contents($TEXT_FILE_LOCATION); // Get the text bytes data from the location

// Let's make a RPC call to the Clarifai platform. It uses the opened gRPC client channel to communicate a
// request and then wait for the response
[$response, $status] = $client->PostModelOutputs(
    // The request object carries the request along with the request status and other metadata related to the request itself
    new PostModelOutputsRequest([
        'user_app_id' => $userDataObject,
        'model_id' => $MODEL_ID,
        'version_id' => $MODEL_VERSION_ID, // This is optional. Defaults to the latest model version
        'inputs' => [
            new Input([ // The Input object wraps the Data object in order to meet the API specification                
                'data' => new Data([ // The Data object is constructed around the Text object. It offers a container that has additional text independent
                    // metadata. In this particular use case, no other metadata is needed to be specified
                    'text' => new Text([ // In the Clarifai platform, a text is defined by a special Text object
                        'raw' => $RAW_TEXT
                        // 'url' => $TEXT_FILE_URL 
                        // 'raw' => $textData 
                    ])
                ])
            ])
        ]
    ]),
    $metadata
)->wait();

// A response is returned and the first thing we do is check the status of it
// A successful response will have a status code of 0; otherwise, there is some error
if ($status->code !== 0) {
    throw new Exception("Error: {$status->details}");
}
// In addition to the RPC response status, there is a Clarifai API status that reports if the operation was a success or failure 
// (not just that the communication was successful)
if ($response->getStatus()->getCode() != StatusCode::SUCCESS) {
    throw new Exception("Failure response: " . $response->getStatus()->getDescription() . " " .
        $response->getStatus()->getDetails());
}

// Save the output image
$output = $response->getOutputs()[0]->getData()->getImage()->getBase64();

$imageFilename = "gen-image.jpg";
file_put_contents($imageFilename, base64_decode($output));

?>
`;

export const textToImageSnippets = {
  [Language.Java]: java,
  [Language.cURL]: cURL,
  [Language.Javascript]: javascript,
  [Language.Python]: python,
  [Language.PythonSDK]: pythonSDK,
  [Language.NodeJS]: nodejs,
  [Language.NodeJS_SDK]: nodejs_SDK,
  [Language.PHP]: php,
};
